import { Component } from '@angular/core';

@Component({
  templateUrl: './truck-journey.component.html'
})
export class TruckJourneyComponent {
}
